import { Store } from 'redux';
import { NotFoundError } from '@cian/peperrors/shared';
import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { createRenderCallback, getFavoritesPage, renderReactApp } from './internal';
import { IApplicationContext } from '../../../shared/App';
import { IApplicationState } from '../../../shared/types/redux';
import { EDeviceType } from '../../../shared/types/device';

export function renderApp(store: Store<IApplicationState>) {
  const config = getConfig();
  const httpApi = getHttpApi();

  const rootElement = document.getElementById('favorites-frontend');

  if (!rootElement) {
    throw new NotFoundError({
      message: 'Unable to find element #favorites-frontend',
      domain: 'services#renderApp',
    });
  }

  const context: IApplicationContext = {
    config,
    httpApi,
    logger: getLogger(),
    deviceType: EDeviceType.Desktop,
  };

  const favoritesPage = getFavoritesPage(context, store);

  renderReactApp({
    app: favoritesPage,
    cb: createRenderCallback(store),
    store,
    rootElement,
  });
}
